//import { navigate } from "gatsby"

export const segmentize = uri =>
  uri
    // strip starting/ending slashes
    .replace(/(^\/+|\/+$)/g, "")
    .split("/");

// Set page but don't reload
export function setPageURL(url, state, replace = false) {
  if (typeof window !== `undefined` && typeof url !== `undefined`) {
    if (replace) {
      window.history.replaceState(state, '', url);
    } else {
      window.history.pushState(state, '', url);
    }
  }
  return
}


export const makeDetailLink = ({
  slugOrId = null,
  type = 'places',
  referrer = null,
  search = null,
  theme = null,
  shouldIncludeTheme = true,
  shouldReplace = false,
}) => {
  console.log('DEBUG: makeDetailLink referrer ', referrer);
  const referrerEncoded = encodeURIComponent(referrer)
  const params = `${referrer ? '?referrer=' + referrerEncoded : ''}${search ? '&' + search : ''}`
  const path = `/${type}/details/${slugOrId}${params}`
  console.log('DEBUG: makeDetailLink ', path, referrer);
  return path
}


export const handleEventRoute = ({
  eventCard = {},
  location = {},
  theme = null,
  shouldIncludeTheme = true,
  shouldReplace = false,
  shouldReload = false,
  shouldOpenURL = false
}) => {
  const { slug, id, url } = eventCard
  //console.log('DEBUG: handleEventRoute ', eventCard, theme);
  let path = `/events/details/${id}${shouldIncludeTheme ? '?theme=' + theme : ''}`

  if (theme == `peoria` || theme == `theme-peoria`) {
    const domain = 'https://peoria.org'
    const slug_without_recurring_date = slug ? slug.split('_')[0] : ''
    path = `${domain}/event/${slug_without_recurring_date}`
  }

  // TODO: This should come from the theme itself, e.g. open_to_website
  if (shouldOpenURL || theme == 'union_square' || theme == 'harlem') {
    path = url
  }

  return path
}

export const handleVenueLink = ({
  place,
  location = {},
  theme = null,
  shouldReplace = false,
  shouldReload = false,
  shouldOpenURL = false
}) => {
  const isGeoJSON = place?.type == 'Feature' || place?.properties != null
  const placeAttributes = isGeoJSON ? place?.properties : place
  const { slug, id, url } = placeAttributes || {}

  const idBest = slug ? slug : id

  let path = `/places/details/${idBest}`

  if (theme == `peoria`) {
    const domain = 'https://peoria.org'
    path = `${domain}/listing/${slug}`
  }

  if (shouldOpenURL || theme == 'union_square' || theme == 'harlem') {
    path = url
  }

  return path
}


export const handlePlaceRoute = ({
  place = null,
  location = {},
  theme = null,
  keepSearch = true,
  leaveMap = false,
  shouldReplace = false,
  shouldReload = false,
  isTitleCard = false,
} = {}) => {
  const isGeoJSON = place?.type == 'Feature' || place?.properties != null
  const placeAttributes = isGeoJSON ? place?.properties : place
  const { slug, id } = placeAttributes || {}
  const paths = location ? segmentize(location.pathname) : []
  const search = location.search
  const currentPage = leaveMap == true ? '/places/details' : `/${paths[0]}`
  const trailingSlash = currentPage.endsWith("/") ? "" : "/"
  const page = currentPage + trailingSlash
  const placeID = slug ? slug : id

  // Add referrer as a query parameter
  const referrer = encodeURIComponent(location.pathname + location.search)

  // TODO: Make reusable
  const hasTheme = theme == `peoria`
  const hasThemeLink = theme == `peoria` && place?.properties?.data_source_url?.includes('peoria')
  const newURL = (hasThemeLink)
    ? place?.properties?.data_source_url
    : `${page}${placeID}${keepSearch ? search : ''}${isTitleCard ? '&hasTitleCard=1' : ''}&referrer=${referrer}`


  if (hasTheme) {
    if (window) {
      window.parent.location.href = newURL
    }
  } else {
    //console.log('Navigating to ', newURL, ' with replace ', shouldReplace, ' and state ', place, '')
    // replace controls whether the current history entry is replaced or a new one is added
    const urlState = {
      place: place
    }

    // Handle reload and broswer history
    const shouldReplace = shouldReload || leaveMap
    setPageURL(newURL, urlState, shouldReplace)
  }
}


export const addSlugToURL = ({
  slug = null,
  location = {},
  pageCurrent = null,
  shouldReplace = false,
  shouldReload = false
}) => {
  const alreadyHasSlug = location.pathname.includes(slug)
  //const alreadyHasID = id && location.pathname.includes(id)
  const includeSearch = true
  // Get page and drop trailing slash
  const pageNoSlash = pageCurrent.replace(/\/$/, "")
  const paths = segmentize(location.pathname)
  const search = location.search

  if (slug && !alreadyHasSlug) {
    // If path has ID, replace with slug
    const newURL = includeSearch
      ? `${pageNoSlash}/${slug}${search}`
      : `${pageNoSlash}/${slug}`

    if (window !== undefined) {
      // TOOO: Set page title
      window.history.replaceState({}, '', newURL)
    }
  }
}

export const removeSlugFromURL = ({
  slug = null,
  location = {},
  pageCurrent = null,
  shouldReplace = false,
  shouldReload = false,
  timeout = 200
}) => {
  const url = location.href
  const urlSearch = new URLSearchParams(location.search)
  const urlPath = location.pathname

  const newPath = urlPath.replace(slug, '')
  const newURL = `${urlSearch.toString() ? newPath + '?' + urlSearch.toString() : newPath}`
  setTimeout(() => {
    if (typeof window !== "undefined" && window.history && window.history.replaceState) {
      window.history.replaceState({}, '', newURL);
    } else if (typeof window?.history !== "undefined") {
      console.warn("window.history is not available. Redirecting to new URL.");
      window.location.href = newURL;
    }
  }, timeout)
}